import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'permissions-select',
    templateUrl: './permissions-select.component.html',
    styleUrls: ['./permissions-select.component.scss']
})
export class PermissionsSelectComponent {
    @Input() permissionsList;
    @Input() permissions;
    @Output() onChange = new EventEmitter<Array<any>>();

    public multiselectSettings = {
        singleSelection: false,
        text: 'Select Access Level',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
        enableSearchFilter: true,
        classes: 'with-filter'
    };

    public onSelect(data): void {
        switch (data.id) {
            case 'resident': {
                this.selectItem('owner_on');
                this.selectItem('rent');

                break;
            }
            case 'rent': {
                if (this.isSet('owner_on')) {
                    this.selectItem('resident');
                }

                break;
            }

            case 'owner_on': {
                if (this.isSet('rent')) {
                    this.selectItem('resident');
                }

                if (this.isSet('owner_off')) {
                    this.selectItem('owner_all');
                }

                break;
            }

            case 'owner_all': {
                this.selectItem('owner_off');
                this.selectItem('owner_on');

                break;
            }
            case 'owner_off': {
                if (this.isSet('owner_on')) {
                    this.selectItem('owner_all');
                }

                break;
            }
        }

        this.onChange.emit(this.permissions);
    }

    public onDeSelect(data): void {
        switch(data.id) {
            case 'rent': {
                this.deSelectItem('resident');

                break;
            }

            case 'owner_on': {
                this.deSelectItem('resident');
                this.deSelectItem('owner_all');

                break;
            }

            case 'owner_off': {
                this.deSelectItem('owner_all');

                break;
            }
        }

        this.onChange.emit(this.permissions);
    }

    private isSet(id) {
        return this.permissions.find(item => item.id === id);
    }

    public selectAll(data) {
        this.permissions = data.map((item) => {
            return this.permissionsList.find(permissions => permissions.id === item.id);
        });

        this.onChange.emit(this.permissions);
    }

    public deSelectAll(data) {
        this.permissions = [];

        this.onChange.emit(this.permissions);
    }

    public selectItem(id) {
        const isSet = this.isSet(id);

        if (!isSet) {
            this.permissions.push(this.permissionsList.find(item => item.id === id));
        }
    }

    public deSelectItem(id) {
        const isSet = this.isSet(id);

        if (isSet) {
            for (let i = 0; i < this.permissions.length; i++) {
                if (this.permissions[i].id === id) {
                    this.permissions.splice(i, 1);

                    return;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/permissions-select/permissions-select.component.ts